import { render, staticRenderFns } from "./CopyrightFooter.vue?vue&type=template&id=be339bb8&lang=html&"
import script from "./CopyrightFooter.vue?vue&type=script&lang=ts&"
export * from "./CopyrightFooter.vue?vue&type=script&lang=ts&"
import style0 from "./CopyrightFooter.vue?vue&type=style&index=0&id=be339bb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports